import { CoreTransaction } from "@/enums";

export default {
  methods: {
    isTransfer(type: string): boolean {
      return type === CoreTransaction.TRANSFER;
    },

    isComment(type: string): boolean {
      return type === CoreTransaction.COMMENT;
    },
    isDeleteComment(type: string): boolean {
      return type === CoreTransaction.DELETE_COMMENT;
    },

    isAccountUpdate(type: string): boolean {
      return type === CoreTransaction.ACCOUNT_UPDATE;
    },

    isAccountUpdate2(type: string): boolean {
      return type === CoreTransaction.ACCOUNT_UPDATE2;
    },

    isAccountClaim(type: string): boolean {
      return type === CoreTransaction.ACCOUNT_CLAIM;
    },
    isClaimAccount(type: string): boolean {
      return type === CoreTransaction.CLAIM_ACCOUNT;
    },

    isAccountCreate(type: string): boolean {
      return type === CoreTransaction.ACCOUNT_CREATE;
    },

    isCustomJson(type: string): boolean {
      return type === CoreTransaction.CUSTOM_JSON;
    },

    isVote(type: string): boolean {
      return type === CoreTransaction.VOTE;
    },

    isClaimReward(type: string): boolean {
      return type === CoreTransaction.CLAIM_REWARD_BALANCE;
    },

    isCurationReward(type: string): boolean {
      return type === CoreTransaction.CURATION_REWARD;
    },

    isDelegateVesting(type: string): boolean {
      return type === CoreTransaction.DELEGATE_VESTING_SHARES;
    },

    isWithdrawVesting(type: string): boolean {
      return type === CoreTransaction.WITHDRAW_VESTING;
    },

    isWithdrawVestingRoute(type: string): boolean {
      return type === CoreTransaction.WITHDRAW_VESTING_ROUTE;
    },

    isWitnessVote(type: string): boolean {
      return type === CoreTransaction.ACCOUNT_WITNESS_VOTE;
    },

    isTransferToSavings(type: string): boolean {
      return type === CoreTransaction.TRANSFER_TO_SAVINGS;
    },
    isTransferToVesting(type: string): boolean {
      return type === CoreTransaction.TRANSFER_TO_VESTING;
    },

    isOrderCreate(type: string): boolean {
      return type === CoreTransaction.LIMIT_ORDER_CREATE;
    },

    isOrderCancel(type: string): boolean {
      return type === CoreTransaction.LIMIT_ORDER_CANCEL;
    },

    isAuthorReward(type: string): boolean {
      return type === CoreTransaction.AUTHOR_REWARD;
    },
    isCommentBenefactorReward(type: string): boolean {
      return type === CoreTransaction.COMMENT_BENEFACTOR_REWARD;
    },
    isFeedPublish(type: string): boolean {
      return type === CoreTransaction.FEED_PUBLISH;
    },
    isProducerReward(type: string): boolean {
      return type === CoreTransaction.PRODUCER_REWARD;
    },
  },
};
